<template>
  <v-card class="archived-popup">
    <div class="close-btn">
      <v-btn icon large @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-card-text>
      <div class="archived-popup__title">
        Let us know why you're {{ isArchived ? 'archiving' : 'pausing' }} this
        project.
      </div>
      <v-radio-group
        v-model="value"
        active-class="active-radio"
        class="archived-popup__list"
      >
        <div
          v-for="(item, index) in archivedOptions"
          :key="index"
          :title="item.title && item.title.length > 35 ? item.title : null"
        >
          <v-radio
            :value="item.key"
            :class="{ 'add-new-text-field': item.key == 1 }"
          >
            <template slot="label">
              <span v-if="item.key !== 5" class="">{{ item.title }} </span>
              <v-text-field
                v-if="item.key == 1"
                v-model="linkedinProfile"
                class="no-detail"
                rows="1"
                :rules="isValidIdealCandidatesRules"
                hide-details
                color="#A1A5A6"
                placeholder="Please provide the candidate’s LinkedIn profile"
                :disabled="value != 1"
              />

              <v-text-field
                v-if="item.key == 5"
                v-model="value_other"
                class="no-detail"
                rows="1"
                :rules="rules"
                hide-details
                color="#A1A5A6"
                placeholder="Other"
                :disabled="value != 5"
              />
            </template>
          </v-radio>
        </div>
      </v-radio-group>
      <div class="d-flex justify-center pb-5 btn-capitalize">
        <v-btn
          color="primary"
          width="156"
          :loading="loading"
          rounded
          x-large
          :disabled="!isValid"
          @click="onSubmit"
        >
          Submit
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { linkedinURL, isLinkedinURL, required } from '@/js/rules';
import { isURL } from '@/utils';

export default {
  name: 'ArchivedPopup',

  props: {
    isArchived: Boolean,
  },

  data() {
    return {
      value_other: '',
      linkedinProfile: '',
      archivedOptions: [
        {
          title: 'Candidate was hired through Hirefly.',
          key: 1,
        },
        {
          title: 'Candidate was hired through other sources.',
          key: 2,
        },
        {
          title: 'We have enough candidates in the pipeline already.',
          key: 3,
        },
        {
          title: 'We no longer have a need for this role.',
          key: 4,
        },
        {
          title: 'Other',
          key: 5,
        },
      ],

      value: '',
      loading: false,
      isValidIdealCandidatesRules: [
        (value) => !!value || 'Required.',
        (value) => isURL(value) || 'URL is not valid',
        linkedinURL,
      ],

      rules: [(value) => !!value?.trim() || 'Required.'],
    };
  },

  computed: {
    isValid() {
      return (
        this.value &&
        ((this.value === 1 &&
          isLinkedinURL(this.linkedinProfile) &&
          isURL(this.linkedinProfile) &&
          !!this.linkedinProfile) ||
          (this.value === 5 && !!this.value_other) ||
          (this.value !== 1 && this.value !== 5))
      );
    },
  },

  methods: {
    onSubmit() {
      const params = {
        paused_archived_reason: this.value,
      };
      if (this.value === 5) {
        params.paused_archived_reason_other = this.value_other;
      }
      if (this.value === 1) {
        params.paused_archived_reason_other = this.linkedinProfile;
      }
      if (this.value) this.$emit('submit', params);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.archived-popup {
  border-radius: 16px !important;
  &__title {
    padding: 48px 20px 0px 20px !important;
    color: $gray-dark;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
  }
  &__list {
    padding-top: 48px;
    padding-bottom: 38px;
    max-width: 446px;
    margin: 0 auto;
    color: $gray-dark;
    font-size: 18px;
    font-weight: 500;
  }
  .close-btn {
    position: absolute;
    top: 3px;
    right: 10px;
    z-index: 999;
  }
  &::v-deep .v-input--radio-group__input {
    gap: 12px;
  }
  &::v-deep .theme--light.v-label {
    color: $gray-dark;
  }
  &::v-deep .v-messages {
    display: none !important;
  }
  .no-detail {
    &::v-deep .v-input__control {
      border-bottom: 1px solid #e6e7eb;
    }
  }
}

.btn-capitalize {
  &::v-deep .v-btn {
    text-transform: capitalize !important;
  }
}
.add-new-text-field {
  align-items: start !important;
  &::v-deep {
    .v-label {
      display: block !important;
    }
    .v-input {
      margin-top: 12px !important;
    }
  }
}
</style>
